import {Component, Input, ViewEncapsulation} from '@angular/core';
import {MenuDateUtil} from '@emm/core/util/menu-date.util';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'emm-attribute-updated-info',
    styleUrls: ['./attribute-updated-info.component.scss'],
    templateUrl: './attribute-updated-info.component.html'
})
export class AttributeUpdatedInfoComponent {

    @Input() lastUpdatedBy: string;
    @Input() lastUpdatedDate: string;

    dateTimeFormat = MenuDateUtil.dateTimeFormat;

    constructor() {}

}
